import { Wording } from '@/types';

export const FITNESS_WORDING_SK: Wording = {
  components_header_media_content: 'Tréningy',
  components_header_media_1: 'Pre mužov',
  components_header_media_2: 'Pre ženy',
  components_header_text1: 'Recepty',
  components_header_text2: 'Blog',
  components_header_members: 'členov',
  hero_text: 'Udržujte svoje telo fit a silné',
  hero_button_text: 'Začnite svoju fitness cestu',
  components_ressources_section_title: 'ZDROJE',
  components_ressources_subheader_text:
    'Všetky zdroje, ktoré potrebujete pre zdravý život',
  components_ressources_span_text:
    'Vyživujte svoju pohodu: Uvoľnite množstvo zdrojov pre holistické zdravie a zdravý život vrátane odborných rád o kondícii, výžive a udržateľnom životnom štýle.',
  components_ressources_card_1_title: 'Motivácia',
  components_ressources_card_1_text:
    'Krátke výbuchy motivácie pre trvalé cvičebné návyky.',
  components_ressources_card_2_title: 'Diéta',
  components_ressources_card_2_text:
    'Inteligentné výživové tipy pre zdravšie a silnejšie vás.',
  components_ressources_link: 'Pozrite si videá',
  components_notes_and_google_title_1: 'fitness tréning',
  components_notes_and_google_title_2: 'Pravidelná rutina',
  components_notes_and_google_title_3: 'Udržiavanie stravy',
  components_review_google_text: 'Recenzia na Googli',
  media_content_section_title: 'TRÉNINGY',
  media_content_section_subheader_text: 'Naše videá',
  text_media_1: 'Muži',
  text_media_2: 'Ženy',
  media_content_section_button_more: 'Ďalšie videá',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Články a správy',
  text2_section_button_more: 'Ďalšie články',
  components_text1_section_title: 'RECEPTY',
  components_text1_subheader_text: 'Zdravá strava pre váš aktívny život',
  components_text1_span_text:
    'Cooking Up Vitality: Preskúmajte svet chutnej kondície s našimi rýchlymi a výživnými receptami.',
  components_text1_card_1_title: 'Naštartujte svoj deň',
  components_text1_card_1_text:
    'Začnite svoje ráno správne s možnosťami raňajok nabitých živinami a bohatými na bielkoviny.',
  components_text1_card_3_title: 'Obedy nabité energiou',
  components_text1_card_3_text:
    'Objavte chutné a pohodlné recepty na obedy navrhnuté pre váš aktívny životný štýl. Od farebných šalátov až po bielkovinové zábaly – tieto recepty vás nabijú energiou a sústredia sa.',
  components_text1_card_2_title: 'Večere na zotavenie',
  components_text1_card_2_text:
    'Preskúmajte rôzne chudé bielkoviny, celozrnné výrobky a živú zeleninu pre uspokojivý koniec dňa.',
  components_text1_link: 'Pozrite si všetky recepty',
  components_footer_text:
    'Zvýšte svoju silu, zapáľte svoju vášeň: Vaša telocvičňa, vaša premena.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registračné číslo',
  components_footer_legal: 'Právne',
  components_footer_terms: 'Zmluvné podmienky',
  components_footer_privacy: 'Zásady ochrany osobných údajov',
  button_load_more: 'Načítať viac',
  page_media_1_content_hero_text: 'Cvičenie pre mužov',
  page_media_content_menu_all: 'Všetky',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Späť',
  page_media_content_menu_chest: 'Hrudník',
  page_media_content_menu_legs: 'Nohy',
  page_media_content_menu_shoulders: 'Ramená',
  page_media_content_menu_abdominals: 'Brucho',
  page_media_2_content_hero_text: 'Tréningy žien',
  page_text1_hero_text: 'Recepty',
  page_text1_section_title: 'Výživa',
  page_text1_subheader_text: 'Recepty',
  page_text2_hero_text: 'Náš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Články a správy',
  enter_email_title: 'Ak chcete pokračovať, zadajte svoj e-mail',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Zadajte',
  components_login_success_text: 'Prihlásenie úspešné!',
  components_card_link_media_content: 'Pozerať teraz',
  components_card_link_text1_content: 'Zobraziť Recept',
  components_card_link_text2_content: 'Zobraziť článok',
  france: 'Francúzsko',
  cyprus: 'Cyprus',
};
